module.exports = __webpack_public_path__ + "img/behold-14.038efd7d.png";